import { render, staticRenderFns } from "./myPopup.vue?vue&type=template&id=7a0d5035&scoped=true"
import script from "./myPopup.vue?vue&type=script&lang=js"
export * from "./myPopup.vue?vue&type=script&lang=js"
import style0 from "./myPopup.vue?vue&type=style&index=0&id=7a0d5035&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0d5035",
  null
  
)

export default component.exports